import { render, staticRenderFns } from "./defaultDetail.vue?vue&type=template&id=b8583fdc&scoped=true&"
import script from "./defaultDetail.vue?vue&type=script&lang=js&"
export * from "./defaultDetail.vue?vue&type=script&lang=js&"
import style0 from "./defaultDetail.vue?vue&type=style&index=0&id=b8583fdc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8583fdc",
  null
  
)

export default component.exports